(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["velras-live-viewers"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-vl-social]').forEach(function(root){
  if(root.__vlInit) return; root.__vlInit = true;
  function hash(str){ var h=0; for(var i=0;i<str.length;i++){ h=(h<<5)-h+str.charCodeAt(i); h|=0; } return Math.abs(h); }
  var pid = root.dataset.pid || 'p';
  var day = new Date(); var seedBase = pid + '-' + day.getFullYear() + '-' + day.getMonth() + '-' + day.getDate() + '-' + day.getHours();
  var vmin = parseInt(root.dataset.vmin,10) || 3, vmax = parseInt(root.dataset.vmax,10) || 19;
  var smin = parseInt(root.dataset.smin,10) || 5, smax = parseInt(root.dataset.smax,10) || 40;
  var vEl = root.querySelector('[data-vl-viewers]'), sEl = root.querySelector('[data-vl-sales]');
  function rangeFromSeed(seedStr, min, max){
    var h = hash(seedStr);
    return min + (h % (max - min + 1));
  }
  var viewers = rangeFromSeed(seedBase + '-v', vmin, vmax);
  var sales = rangeFromSeed(seedBase + '-s', smin, smax);
  if(vEl) vEl.textContent = viewers;
  if(sEl) sEl.textContent = sales;
  if(vEl){
    setInterval(function(){
      var delta = (Math.random() > 0.5 ? 1 : -1);
      viewers = Math.min(vmax, Math.max(vmin, viewers + delta));
      vEl.textContent = viewers;
    }, 25000);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["velras-urgency-timer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-vl-timer]').forEach(function(root){
  if(root.__vlInit) return; root.__vlInit = true;
  var hours = parseFloat(root.dataset.hours) || 24;
  var key = 'vl_timer_' + (root.className.match(/vl-timer-([a-zA-Z0-9_-]+)/) || ['',''])[1];
  var now = Date.now();
  var deadline = parseInt(localStorage.getItem(key), 10);
  if(!deadline || isNaN(deadline) || deadline < now){
    deadline = now + hours * 3600 * 1000;
    try{ localStorage.setItem(key, deadline); }catch(e){}
  }
  var h = root.querySelector('[data-h]'), m = root.querySelector('[data-m]'), s = root.querySelector('[data-s]');
  function pad(n){ return n < 10 ? '0'+n : ''+n; }
  function tick(){
    var diff = deadline - Date.now();
    if(diff <= 0){
      deadline = Date.now() + hours * 3600 * 1000;
      try{ localStorage.setItem(key, deadline); }catch(e){}
      diff = deadline - Date.now();
    }
    var totalH = Math.floor(diff / 3600000);
    var mm = Math.floor((diff % 3600000) / 60000);
    var ss = Math.floor((diff % 60000) / 1000);
    if(h) h.textContent = pad(totalH);
    if(m) m.textContent = pad(mm);
    if(s) s.textContent = pad(ss);
  }
  tick();
  setInterval(tick, 1000);
});
  } catch(e) { console.error(e); }
})();

})();
